import React from 'react';
import reportError from '@src/helpers/reportError';
import Translate from '../Translate/Translate';
import RenderIf from '../RenderIf/RenderIf';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import {PopupProps, PopupState} from '@src/@types/components/Popup';
import {PopupContext} from '@src/components/Popup/PopupContext';

export default class Popup extends React.Component<PopupProps, PopupState> {
    state: PopupState = {
        width: undefined,
        displayLoadingIndicator: undefined,
    };

    protected popupContextValue: React.ContextType<typeof PopupContext> | null = null;

    constructor(props: PopupProps) {
        super(props);

        this.state = {
            width: props.width,
            displayLoadingIndicator: props.displayLoadingIndicator,
        };
    }

    protected isClosable(): boolean {
        return this.props.closable ?? true;
    }

    protected renderTitle() {
        let title = this.props.title;
        if (typeof title === 'function') {
            try {
                title = title();
            } catch (e: any) {
                reportError(e);
            }
        }

        if (!title) {
            return null;
        }

        if (typeof title === 'string') {
            return <Translate message={title} tag="div" className="card-title custom-popup__title"/>;
        }

        return <div className="card-title custom-popup__title">{title}</div>;
    }

    protected renderCloseButton() {
        const dismiss = this.props.closePopup;
        if (!this.isClosable() || !dismiss) {
            return null;
        }

        return <button className="custom-popup__close-button" onClick={() => dismiss()}>
            <i className="fas fa-times"/>
        </button>;
    }

    protected getPopupContextValue(): React.ContextType<typeof PopupContext> {
        return this.popupContextValue ??= [
            () => this.state,
            this.setState.bind(this),
        ];
    }

    render() {
        const width = this.state.width ?? this.props.width;
        const displayLoadingIndicator = this.state.displayLoadingIndicator ?? this.props.displayLoadingIndicator;

        return <div
                className="card shadow-lg custom-popup"
                style={width ? {width} : undefined}
        >
            <PopupContext.Provider value={this.getPopupContextValue()}>
                {this.renderCloseButton()}
                {this.renderTitle()}

                <LoadingIndicator
                        type="linear"
                        className={displayLoadingIndicator ? undefined : 'opacity-0'}
                />

                <div className="custom-popup__body card-body">
                    {this.props.children}
                </div>

                <RenderIf expression={this.props.footer}>
                    <div className="card-footer custom-popup__footer">
                        {this.props.footer}
                    </div>
                </RenderIf>
            </PopupContext.Provider>
        </div>;
    }
}
